// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../onehivesystems/js/OHSApp';
import OHSWidget from '../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
// Assets
import './UserAccounts.scss';
import User from './Modules/User';
import { userAccountModel, privilegeLevels } from './_variables';


// COMPONENT
export default function UserAccounts (props) {
   // States and Variables
   const [userAccounts, setUserAccounts] = useState(null);
   const [userAccountPopups, setUserAccountPopups] = useState({});
   const [isAdministrator, setIsAdministrator] = useState(false);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("User Accounts"); // set page title
      getUserAccounts();
   }, []);

   // Functions
   const getUserAccounts = function () {
      OHSCRUD({
         url: '/v1/useraccounts',
         method: 'GET',
         success: function (data) {
            setUserAccounts(OHSListDataFormatter(data, userAccountModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addUserAccount = function () {
      OHSCRUD({
         url: '/v1/useraccounts',
         method: 'POST',
         payload: OHSFormDataExtractor('useraccounts-add'),
         success: function (data) {
            if (userAccounts.length > 0) {
               setUserAccounts([...userAccounts, OHSListDataFormatter(data[0], userAccountModel)]);
            } else {
               setUserAccounts([OHSListDataFormatter(data[0], userAccountModel)]);
            }
            OHSFormDataClearer('useraccounts-add');
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      })
   }
   const toggleIsAdministrator = function (event) {
      if (event.target.value === "Administrator") {
         setIsAdministrator(true);
      } else {
         setIsAdministrator(false);
      }
   }

   // Component
   return (
      <div className="useraccounts">
         <OHSAppHeader onehive={props.onehive} title="User Accounts" help="https://www.onehivesystems.com/documentation/useraccounts" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='useraccounts-add' className='useraccounts-add' title="Add a Local User Account" onEnter={addUserAccount}>
               <OHSFormItem onehive={props.onehive} title="Username">
                  <input type='text' className='ohsinput' data-ohsformdata='username' min={1} max={256} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Password">
                  <input type='password' className='ohsinput' data-ohsformdata='password' min={1} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Confirm Password">
                  <input type='password' className='ohsinput' data-ohsformdata='confirm_password' min={1} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="First Name">
                  <input type='text' className='ohsinput' data-ohsformdata='first_name' placeholder="(Optional)" min={0} max={256} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Last Name">
                  <input type='text' className='ohsinput' data-ohsformdata='last_name' placeholder="(Optional)" min={0} max={256} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Privilege Level">
                  <OHSFormSelectBuilder onehive={props.onehive} content={privilegeLevels} simple={true} blank={false} ohsformdata='privilege_level' onchange={(e) => {toggleIsAdministrator(e);}} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Access: OneACL">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneacl' disabled={isAdministrator} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Access: OneChange">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='app_onechange' disabled={isAdministrator} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Access: OneEye">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneeye' disabled={isAdministrator} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Access: OneIP">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneip' disabled={isAdministrator} />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Access: OnePort">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='app_oneport' disabled={isAdministrator} />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addUserAccount} clear={() => {OHSFormDataClearer('useraccounts-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter User Accounts" container='useraccounts-list' />
            <OHSWidget onehive={props.onehive} id='useraccounts-list' title="List of User Accounts">
               <OHSList onehive={props.onehive} content={userAccounts} popups={userAccountPopups} setPopups={setUserAccountPopups} template={
                  <User onehive={props.onehive} parent={{
                     userAccounts: userAccounts,
                     setUserAccounts: setUserAccounts
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}